var Promise = require('bluebird');
var ApplicationAPI = require('../../../../common/api').Application;
var auth = require('../../../../common/auth')

module.exports = function($scope, tab, applicationId, items){
  $scope.items = items;
  $scope.stats = {};
  $scope.applicationId = applicationId;
  $scope.isFunder = auth.hasClaims([{type: "user_role", value: "funder"}]);

  $scope.list = null;
  $scope.currentTab = tab;
  //Preventing applicant from seeing funder details unless it is an offer
  $scope.masked = !$scope.isFunder && tab !== "offers";

  $scope.init = function(){
    $scope.loading = true;
    ApplicationAPI.GetApplicationStats(applicationId).then(function(result){
      $scope.stats = result;
      $scope.list = $scope.stats[$scope.currentTab];
      $scope.loading = false;
    });
  }

  $scope.init();

  $scope.switchTo = function(str){
    $scope.currentTab = str;
    $scope.list = $scope.stats[str];
    $scope.masked = !$scope.isFunder && (str !== "offers")
  }
}
